// Mock data for Dream Sports Foundation

export const mockData = {
  hero: {
    videoUrl: '/hero-video.mp4',
    mission: 'Make sports a viable career pathway in India.'
  },
  
  programs: [
    {
      id: 1,
      title: 'Dream Sports Championship',
      description: 'Creating world-class competitions across multiple sports for youth talent',
      image: '/dream-sports-championship.mp4',
      link: '/programs#dream-sports-championship'
    },
    {
      id: 2,
      title: 'Dream Again\nEducation Workshops',
      description: 'Education and upskilling initiative for athlete support systems – coaches, referees, sports scientists and more',
      image: '/dream-again.mp4',
      link: '/programs#dream-again'
    },
    {
      id: 3,
      title: 'Dream Sports MSSA Tournaments',
      description: 'Elevating school sport in Mumbai with better facilities, quality officiating, enhanced training, live streaming, and wider recognition.',
      image: '/dream-sports-mssa.mp4',
      link: '/programs#dream-sports-mssa-tournaments'
    }
  ],
  
  focusAreas: [
    {
      id: 1,
      title: 'Long Term Athlete Development',
      description: 'Structured pathways for athletes from grassroots to elite levels',
      icon: 'TrendingUp'
    },
    {
      id: 2,
      title: 'Youth Competitions & Leagues',
      description: 'Creating competitive platforms for young talent to flourish',
      icon: 'Trophy'
    },
    {
      id: 3,
      title: 'Talent Identification',
      description: 'Scientific approaches to discovering and nurturing sporting talent',
      icon: 'Target'
    },
    {
      id: 4,
      title: 'Sports Science & Innovations',
      description: 'Leveraging technology and research for athlete performance',
      icon: 'Zap'
    },
    {
      id: 5,
      title: 'Education & Upskilling',
      description: 'Building capacity through training and knowledge development',
      icon: 'GraduationCap'
    }
  ],
  
  impact: [
    {
      id: 1,
      number: '8000+',
      label: 'Athlete & Coach beneficiaries'
    },
    {
      id: 2,
      number: '32',
      label: 'Elite athletes supported'
    },
    {
      id: 3,
      number: '120+',
      label: 'Medals for India'
    },
    {
      id: 4,
      number: '250',
      label: 'Junior Athletes Across 6 Sports'
    },
    {
      id: 5,
      number: '1,00,000+',
      label: 'Students in 400+ Schools (Mumbai)'
    },
    {
      id: 6,
      number: '700+',
      label: 'Coaches & Sports Scientists Upskilled'
    }
  ],
  
  stories: [
    {
      id: 1,
      title: 'Rising Stars: The Journey of Young Champions',
      excerpt: 'How our programs are shaping the next generation of Indian athletes through structured development pathways.',
      image: 'https://images.pexels.com/photos/163239/baseball-player-running-sport-163239.jpeg',
      date: '2024-12-15',
      category: 'Success Story'
    },
    {
      id: 2,
      title: 'Partnership with National Sports Federations',
      excerpt: 'Collaborating with SAI, TTFI & AIFF to create comprehensive athlete support systems.',
      image: 'https://images.pexels.com/photos/15193118/pexels-photo-15193118.jpeg',
      date: '2024-12-10',
      category: 'Partnership'
    }
  ],
  
  mediaHub: [
    {
      id: 1,
      type: 'news',
      title: 'Dream Sports Foundation Announces New Initiative',
      excerpt: 'Expanding reach to 100+ new schools across India',
      image: 'https://images.pexels.com/photos/35131411/pexels-photo-35131411.jpeg',
      url: '#',
      date: '2024-12-20'
    },
    {
      id: 2,
      type: 'media',
      title: 'Athletes Share Their Success Stories',
      excerpt: 'Video series featuring medal winners from our programs',
      image: 'https://images.pexels.com/photos/31131695/pexels-photo-31131695.jpeg',
      url: '#',
      date: '2024-12-18'
    },
    {
      id: 3,
      type: 'social',
      title: 'Behind the Scenes: Training Camp',
      excerpt: 'A glimpse into the intensive preparation of our elite athletes',
      image: 'https://images.pexels.com/photos/35131371/pexels-photo-35131371.jpeg',
      url: '#',
      date: '2024-12-15'
    },
    {
      id: 4,
      type: 'news',
      title: 'Partnership with Leading Sports Brands',
      excerpt: 'New collaborations to enhance athlete support',
      image: 'https://images.pexels.com/photos/264312/pexels-photo-264312.jpeg',
      url: '#',
      date: '2024-12-12'
    },
    {
      id: 5,
      type: 'media',
      title: 'Coach Development Workshop Series',
      excerpt: 'Upskilling 200+ coaches with latest sports science',
      image: 'https://images.pexels.com/photos/30644304/pexels-photo-30644304.jpeg',
      url: '#',
      date: '2024-12-08'
    },
    {
      id: 6,
      type: 'social',
      title: 'Youth Championship Highlights',
      excerpt: 'Celebrating young talent at our annual event',
      image: 'https://images.pexels.com/photos/31772338/pexels-photo-31772338.jpeg',
      url: '#',
      date: '2024-12-05'
    }
  ],
  
  partners: [
    { id: 1, name: 'All India Football Federation', logo: '/partner-aiff.png' },
    { id: 2, name: 'Sports Authority of India', logo: '/partner-sai.png' },
    { id: 3, name: 'Table Tennis Federation of India', logo: '/partner-ttfi.webp' },
    { id: 4, name: 'Indian Football Foundation', logo: '/partner-iff.jpg' },
    { id: 5, name: 'MKRBF', logo: '/partner-mkrbf.png' },
    { id: 6, name: 'Lakshya', logo: '/partner-lakshya.png' },
    { id: 7, name: 'MP Sports', logo: '/partner-mp.png' },
    { id: 8, name: 'Ultimate Table Tennis', logo: '/partner-utt.png' },
    { id: 9, name: 'MSSA 125 Years', logo: '/partner-mssa.png' },
    { id: 10, name: 'Vidya Foundation', logo: '/partner-vidya.png' },
    { id: 11, name: 'Government of Karnataka', logo: '/partner-karnataka.jpg' }
  ],
  
  socialMedia: {
    instagram: 'https://instagram.com/dreamsportsfoundation',
    twitter: 'https://x.com/thdsfofficial',
    linkedin: 'https://www.linkedin.com/company/dreamsportsfoundation'
  }
};